<h1>Sponsors</h1>

<div class="card">
  <div class="card-header">
    Sponsors <a id='sponsorsListingNew' *ngIf="!loading && sponsors.length == 0" [routerLink]="['/admin/sponsors/add']" class="btn btn-default pull-right">New</a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === sponsors.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < sponsors.length">
        <thead>
          <tr>
            <th><span class="col-name">Name</span></th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sponsor of sponsors; let i = index">
            <td>{{ sponsor.name }}</td>
            <td class="col-md-1">
              <a class="btn btn-primary" [routerLink]="['/admin/sponsors/edit']" [queryParams]="{ id: sponsor.id }">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/sponsors-listing/sponsors-listing.component.html